import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppControlRoutingModule } from './app.control.routes';
import { ToastModule } from 'primeng/toast';
import { ButtonModule} from 'primeng/button';
import { TabViewModule} from 'primeng/tabview';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/components/slider/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';

import {MessageService} from 'primeng/api';
import { ControlComponent } from './components/control/control.component';
import { CrearControlComponent } from './components/crear-control/crear-control.component';
import { ControlService } from 'src/app/services/control/control.service';
import { EditControlComponent } from './components/edit-control/edit-control.component';

import { ImprimirSharedModule } from 'src/app/components/imprimir/imprimir.module.share';
import { UserLoginService } from 'src/app/services/UserLogin/userLoginService';
import { ImprimirControlSharedModule } from 'src/app/components/imprimir/imprimir-control/imprimirControl.module.share';
import {CheckboxModule} from 'primeng/checkbox';
import { ImprimirControlMultipleSharedModule } from 'src/app/components/imprimir-multilples/imprimir-control/imprimirControlMultiple.module.share';
import { SimpleTableModule } from 'src/app/components/table/simple-table/simple-table.modules';




@NgModule({
    declarations: [
     
        ControlComponent,
        CrearControlComponent,
        EditControlComponent,
        
    
    ],
    imports: [ 
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ToastModule,
        ButtonModule,
        TabViewModule,
        CodeHighlighterModule,
        TableModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        MultiSelectModule,
        SliderModule,
        CalendarModule,
        RadioButtonModule,
        InputSwitchModule,
        ConfirmDialogModule,
        ImprimirSharedModule,
        ImprimirControlSharedModule,
        ImprimirControlMultipleSharedModule,
        CheckboxModule,
        SimpleTableModule,
        AppControlRoutingModule 
    ],
    exports: [
        ControlComponent,
        CrearControlComponent,
        EditControlComponent,
      
    ],
    providers: [
        MessageService,
        ControlService,
        ConfirmationService,
        UserLoginService,
    ],
    bootstrap: []
})
export class ControlCristalModule {}